import { useSetTimeout } from '@fluentui/react-hooks';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
/** Sends the user to `to` after `delay` (ms) */
export const useRedirectAfterDelayEffect = (to = process.env.PUBLIC_URL, delay = 10000) => {
    const { push, location } = useHistory();
    const { setTimeout, clearTimeout } = useSetTimeout();
    useEffect(() => {
        const id = setTimeout(() => {
            push(Object.assign(Object.assign({}, location), { pathname: to }));
        }, delay);
        return () => {
            if (id) {
                clearTimeout(id);
            }
        };
    }, [setTimeout, clearTimeout, push, delay, location, to]);
};
